import type { Instance, SnapshotOut } from 'mobx-state-tree'
import { types } from 'mobx-state-tree'

import { Consts } from '../../configs/consts'
import { getObjectKeys } from '../../utils/objects'
import { withRootStore } from './helpers/withRootStore'
import { withSetProp } from './helpers/withSetProp'

export const ConfigStoreModel = types
  .model('ConfigStore')
  .props({
    consts: types.optional(types.frozen<typeof Consts>(), Consts),
    envOverride: types.maybe(types.frozen<(typeof Consts)['env']>()),
    flags: types.maybe(types.frozen<ConfigFlags>()),
  })
  .extend(withRootStore)
  .extend(withSetProp)
  .views(self => ({
    get envs(): (typeof Consts)['env'][] {
      return getObjectKeys(self.consts.environments ?? {})
    },
    get env() {
      return (self.envOverride ?? self.consts.env)!
    },
    get environment() {
      return self.consts.environments?.[this.env!]
    },
  }))
  .actions(self => ({
    overrideEnv(env: (typeof Consts)['env']) {
      self.setProp('envOverride', env)
    },
    toggleFlag<K extends keyof ConfigFlags>(key: K) {
      self.flags = { ...self.flags, [key]: !self.flags?.[key] }
    },
    async afterAttach() {
      if (self.envOverride) {
        self.rootStore.api.setBaseUrl(self.environment?.apiBaseUrl ?? '')
      }
    },
  }))

type ConfigFlags = {
  allowImport?: boolean
  showArhived?: boolean
}

export interface ConfigStore extends Instance<typeof ConfigStoreModel> {}
export interface ConfigStoreSnapshot extends SnapshotOut<typeof ConfigStoreModel> {}
